import { render, staticRenderFns } from "./DocumentsDialogGlobal.vue?vue&type=template&id=ea1d651e"
import script from "./DocumentsDialogGlobal.vue?vue&type=script&lang=js"
export * from "./DocumentsDialogGlobal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports